import {
  FETCH_INTERVIEWS_STARTED,
  FETCH_INTERVIEWS_SUCCESS,
  FETCH_INTERVIEWS_FAILURE,
  FETCH_ONE_INTERVIEW_STARTED,
  FETCH_ONE_INTERVIEW_SUCCESS,
  FETCH_ONE_INTERVIEW_FAILURE,
  CREATE_INTERVIEWS_STARTED,
  CREATE_INTERVIEWS_FAILURE,
  DELETE_INTERVIEWS_STARTED,
  DELETE_INTERVIEWS_FAILURE,
  UPDATE_INTERVIEWS_STARTED,
  UPDATE_INTERVIEWS_FAILURE
} from "../actions/types";

const initialInterviewsState = {
  loading: false,
  data: [],
  error: null
};

export const interviews = (state = initialInterviewsState, action) => {
  switch (action.type) {
    case FETCH_INTERVIEWS_STARTED:
      return {
        ...state,
        loading: true
      };
    case FETCH_INTERVIEWS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload
      };
    case FETCH_INTERVIEWS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    case CREATE_INTERVIEWS_STARTED:
      return {
        ...state,
        loading: true
      };
    case CREATE_INTERVIEWS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    case DELETE_INTERVIEWS_STARTED:
      return {
        ...state,
        loading: true
      };
    case DELETE_INTERVIEWS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    case UPDATE_INTERVIEWS_STARTED:
      return {
        ...state,
        loading: true
      };
    case UPDATE_INTERVIEWS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    default:
      return state;
  }
};

const initialInterviewState = {
  loading: false,
  data: {},
  error: null
};

export const interview = (state = initialInterviewState, action) => {
  switch (action.type) {
    case FETCH_ONE_INTERVIEW_STARTED:
      return {
        ...state,
        loading: true
      };
    case FETCH_ONE_INTERVIEW_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload
      };
    case FETCH_ONE_INTERVIEW_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    default:
      return state;
  }
};
